import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21462cdb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "callback",
  class: "flex"
}
const _hoisted_2 = {
  key: 0,
  class: "flex"
}
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Looks like you're logging in via a different browser. Please confirm your email", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Confirm", -1))

import { inject, onMounted, ref } from "vue";
import userStore from "@/store/userStore";
import { isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";
import { auth } from "@/assets/ts/firebase";
import { useRouter } from "vue-router";
import { SHOW_TOAST } from "@/assets/ts/Constants";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

var mitt = inject("emitter") as any;

var router = useRouter();

var email = ref<string | null>();
var showConfirm = ref(false);

onMounted(async () => {
  // Confirm the link is a sign-in with email link.
  if (isSignInWithEmailLink(auth, window.location.href)) {
    email.value = window.localStorage.getItem("emailForSignIn");
    if (email.value) signIn();
    else showConfirm.value = true;
  }
});

const confirm = () => {
  signIn();
};

const signIn = () => {
  if (email.value == null) return;
  signInWithEmailLink(auth, email.value, window.location.href)
    .then((result) => {
      window.localStorage.removeItem("emailForSignIn");
      userStore.setUser(result.user);
      router.push("/");
    })
    .catch((error) => {
      mitt.emit(SHOW_TOAST, { title: "Woops", msg: "Invalid email", type: "error" } as toastConfig);
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(showConfirm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(confirm, ["prevent"]),
            class: "flex"
          }, [
            _hoisted_4,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              placeholder: "Confirm your email...",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : email = $event))
            }, null, 512), [
              [_vModelText, _unref(email)]
            ]),
            _hoisted_5
          ], 40, _hoisted_3)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})